<!-- product add button -->
<div class="qty-controller-comp">
  <div
    (click)="onDecrease()"
    [class.disabled-decrement-action]="!canDecrease()"
    class="det-default-qty-action"
  >
    <span class="qty-action-minus"></span>
  </div>
  <span
    ><input
      class="det-default-qty-input disabled-input-action"
      type="text"
      (focusout)="changeQuantity(input.value)"
      [value]="currentValue()"
      #input
  /></span>
  <div (click)="onIncrease()" class="det-default-qty-action">
    <span class="qty-action-plus"></span>
  </div>
</div>
